import { SVGProps } from "react";

const STIOpensource = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Open Source" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><path fill="#3da639" stroke="#1d531d" strokeWidth={14} strokeLinejoin="round" d="M192 430a180 180 0 11128 0l-40-109a63 63 0 10-48 0z" /></svg>;

export { STIOpensource };